import { useI18n } from "@/shared/i18n"
import { cn } from "@/shared/lib/utils"

interface InventoryEmptyActionsProps {
  onSend?: () => void
  onGoShopping?: () => void
  /** Shop is gated until the shop feature lands. */
  shopDisabled?: boolean
}

export function InventoryEmptyActions({
  onSend,
  onGoShopping,
  shopDisabled = true,
}: InventoryEmptyActionsProps) {
  const { t } = useI18n()

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-[calc(4rem+var(--app-safe-bottom))] z-40 flex flex-col items-stretch bg-gradient-to-b from-transparent to-primary-main pt-16 sm:bottom-[calc(5rem+var(--app-safe-bottom))]">
      <div className="pointer-events-auto mx-auto flex w-full max-w-[390px] gap-2 p-4">
        <button
          type="button"
          onClick={onSend}
          className="flex h-12 flex-1 items-center justify-center rounded-2xl bg-white text-[16px] font-bold leading-[19px] tracking-[-0.5px] text-black-100 transition-transform active:scale-[0.98]"
        >
          {t("inventory.empty.send")}
        </button>
        <button
          type="button"
          onClick={onGoShopping}
          disabled={shopDisabled}
          className={cn(
            "flex h-12 flex-1 items-center justify-center rounded-2xl text-[16px] font-bold leading-[19px] tracking-[-0.5px] text-black-100 transition-transform active:scale-[0.98]",
            shopDisabled
              ? "cursor-not-allowed bg-[#00FE74]/40"
              : "bg-[#00FE74]"
          )}
        >
          {t("inventory.empty.goShopping")}
        </button>
      </div>
    </div>
  )
}
